$ = jQuery;
jQuery(document).ready(() => {
    siteHeader.init();
    mobileSlider.init();
    vsplSliders.init();
    storyPageSlider.init();
    sitePopup.init();
    vsplAjax.init();
});

jQuery(document).ready(function () {
    jQuery(document).on("click", '[data-element="calculate-saving"]', function (e) {
        var allFilled = true;
        jQuery('[data-element="distance"]').removeClass("error");
        jQuery('[data-element="fuel-mileage"]').removeClass("error");
        jQuery('[data-element="fuel-price"]').removeClass("error");
        jQuery('[data-element="ev-range"]').removeClass("error");
        jQuery('[data-element="ev-capacity"]').removeClass("error");
        jQuery('[data-element="ev-tariff"]').removeClass("error");

        //Total Travel
        var totalTravelDistance = parseFloat(jQuery('[data-element="distance"]').val());

        //Fuel Details
        var fuelMileage = parseFloat(jQuery('[data-element="fuel-mileage"]').val());
        var fuelPrice = parseFloat(jQuery('[data-element="fuel-price"]').val());

        //EV Details
        var evRange = parseFloat(jQuery('[data-element="ev-range"]').val());
        var evCapacity = parseFloat(jQuery('[data-element="ev-capacity"]').val());
        var evTariff = parseFloat(jQuery('[data-element="ev-tariff"]').val());

        if (!!totalTravelDistance == false) {
            jQuery('[data-element="distance"]').addClass("error");
            allFilled = false;
        }
        if (!!fuelMileage == false) {
            jQuery('[data-element="fuel-mileage"]').addClass("error");
            allFilled = false;
        }
        if (!!fuelPrice == false) {
            jQuery('[data-element="fuel-price"]').addClass("error");
            allFilled = false;
        }
        if (!!evRange == false) {
            jQuery('[data-element="ev-range"]').addClass("error");
            allFilled = false;
        }
        if (!!evCapacity == false) {
            jQuery('[data-element="ev-capacity"]').addClass("error");
            allFilled = false;
        }
        if (!!evTariff == false) {
            jQuery('[data-element="ev-tariff"]').addClass("error");
            allFilled = false;
        }

        if (allFilled == true) {

            jQuery('[data-element="info"]').hide();
            jQuery('[data-element="result"]').show();

            //Fuel Calculate Costs
            let fuelPerKmCost = parseFloat(fuelPrice / fuelMileage);
            let fuelTravelCost = parseFloat(fuelPerKmCost * totalTravelDistance);

            //EV Calculate Costs
            let evPerKmCost = parseFloat((evCapacity / evRange) * evTariff);
            let evTravelCost = parseFloat(evPerKmCost * totalTravelDistance);

            //EV Saving
            if (fuelTravelCost > evTravelCost) {
                var savings = parseFloat(fuelTravelCost - evTravelCost).toFixed(2);
                jQuery('[data-element="saving--value"]').html(savings);
                jQuery('[data-element="totalsaving"]').show();
                jQuery('[data-element="nosaving"]').hide();
            }

            //Fuel Saving
            if (evTravelCost > fuelTravelCost) {
                jQuery('[data-element="totalsaving"]').hide();
                jQuery('[data-element="nosaving"]').show();
            }

            jQuery('[data-element="fuelpercost"]').html(fuelPerKmCost.toFixed(2));
            jQuery('[data-element="fueltotalcost"]').html(fuelTravelCost.toFixed(2));
            jQuery('[data-element="evpercost"]').html(evPerKmCost.toFixed(2));
            jQuery('[data-element="evtotalcost"]').html(evTravelCost.toFixed(2));
        }
    });

    jQuery(document).on('click', '[data-element="donationclose"]', function () {
        document.cookie = "stickydonation=triggred; path=/";
        jQuery('[data-element="stickydonation"]').fadeOut("slow").remove();
    });


    //Sticky Donation 
    setTimeout(() => {
        jQuery('[data-element="stickydonation"]').fadeIn();
    }, 10000);
});


jQuery(window).load(function () {
    quiz.init();
    setTimeout(() => {
        siteHeader.notificationSlide();
    }, 5000);



    let topicNavButton = document.getElementById('topicsnavarrow');
    if (!!topicNavButton !== false) {
        let topicScroll = 0;
        let topicContainer = document.getElementById('terms-slider');
        topicNavButton.onclick = function () {
            topicScroll = topicContainer.scrollLeft;
            sideScroll(topicContainer, 'right', 25, 200, 20);
            setTimeout(() => {
                if (topicScroll == document.getElementById('terms-slider').scrollLeft) {
                    sideScroll(topicContainer, 'left', 5, topicScroll, topicScroll);
                }
            }, 1000);
        };

        function sideScroll(element, direction, speed, distance, step) {
            let scrollAmount = 0;
            let slideTimer = setInterval(function () {
                if (direction == 'left') {
                    element.scrollLeft -= step;
                } else {
                    element.scrollLeft += step;
                }
                scrollAmount += step;
                if (scrollAmount >= distance) {
                    window.clearInterval(slideTimer);
                }
            }, speed);
        }
    }
});


jQuery(document).ready(function () {
    jQuery(window).scroll(function () {
        var pixels = jQuery(document).scrollTop();
        var pageHeight = jQuery(document).height() - jQuery(window).height();
        var progress = 100 * pixels / pageHeight;

        jQuery(".article-progress").css("width", progress + "%");

        jQuery('.featured-topics').toggleClass('fixed-topics', jQuery(window).scrollTop() >= 200);
    });
    jQuery('.vspl__scrolltop-clicked').on('click', function () {
        jQuery('html, body').animate({
            scrollTop: jQuery('html, body').offset().top,
        }, "1000");
    });

    jQuery('[data-element="viewjoblisting"]').on('click', function () {
        jQuery('html, body').animate({
            scrollTop: jQuery('#joblistingpanel').offset().top,
        }, "1000");
    });
});